import { IconInfoCircle } from '@tabler/icons-react';
import clsx from 'clsx';
import { UserError } from '@/lib/graphql/errors';

interface ErrorMessageProps {
  errors?: readonly UserError[] | null;
  className?: string;
}

export const ErrorMessage = ({ errors, className = '' }: ErrorMessageProps) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className={clsx('text-sm text-red-600', className)}>
      {errors.map((error) => (
        <div key={error.code} className="flex items-start">
          <IconInfoCircle className="mr-2 mt-0.5 size-4 shrink-0" />
          <span>{error.message}</span>
        </div>
      ))}
    </div>
  );
};
